export default import.meta.ROLLDOWN_FILE_URL_V47HoeQBgiUEQbXS1PpE9g